export default __webpack_public_path__ + "static/media/fondo_icono.b8c09866.jpg";